import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

export default {
  preset: definePreset(Lara, {
    semantic: {
      // VoteWise brand — forest green (700/800 anchor the brand #0f2a1d)
      primary: {
        50: '#eef2ef',
        100: '#d3e0d8',
        200: '#a7c1b1',
        300: '#79a088',
        400: '#4b7860',
        500: '#2b5540',
        600: '#1c4230',
        700: '#143324',
        800: '#0f2a1d',
        900: '#0a1f15',
        950: '#05100b',
      },
      colorScheme: {
        light: {
          formField: {
            disabledColor: '#827b72',
            disabledBackground: '#e8e3db',
          },
        },
      },
    },
  }),
  options: {
    darkModeSelector: false,
  },
};
